<template lang="pug">
  .multi-select-buttons
    .button-wrap(v-for="(option, index) in options" :key="index")
      button.multi-select-button.btn-reset.xs-f-small.max-at-tweak(@click="update(option.value)" :disabled="option.disabled" :class="{ selected: valueSelected(option.value), disabled: option.disabled }") {{option.label}}

</template>

<script>
  export default {
    name: "MultiSelectButtons",

    props: {
      modelValue: {
        type: Array
      },
      options: {
        type: Array,
        default: () => ([])
      }
    },

    emits: ['update:modelValue'],

    methods: {
      valueSelected(val) {
        return this.modelValue.indexOf(val) != -1;
      },

      update(val) {
        var newValue = [];

        this.options.forEach(option => {
          var index = this.modelValue.indexOf(option.value);

          if ((index != -1 && option.value != val) || (index == -1 && option.value == val)) {
            newValue.push(option.value);
          }
        });

        this.$emit('update:modelValue', newValue);
      }
    }
  };
</script>

<style lang="stylus">
  .multi-select-buttons
    .button-wrap
      width 50%
      display inline-block
      vertical-align top
      padding 1.5%

    .multi-select-button
      position relative
      padding 1em 1.5em
      width 100%

      &:before
        content ''
        background transparent
        position absolute
        top 0
        right 0
        bottom 0
        left 0
        pointer-events none
        border-radius 0.5em
        border 1px solid color-gray-triple-nines

      &.selected
        color brand-color-2

        &:before
          border 3px solid brand-color-2

      &.disabled
        color color-fog

        &:before
          border-color #ebebeb

    &.modal-buttons
      .multi-select-button
        padding 0 0
        height 3.5em
</style>
